<template>
    <el-skeleton :loading="loading" :rows="16" animated>
        <el-page class="invest-page" :bannerImageUrl="bannerImageUrl">
            <div class="investment-idea">
                <pane-title class="pane" title="投资理念" subTitle="FOCUS TRACKS" />
                <swiper class="idea-list-mobile" :options="swiperOption">
                    <swiper-slide v-for="(item, index) in ideaList" :key="index" class="idea-item">
                        <div class="image-container">
                            <img :src="item.pcImgUrl" />
                        </div>
                        <div class="content">
                            <div class="title">{{ item.title }}</div>
                            <div class="description">
                                <p v-for="(paragraph, pIndex) in item.description.split('|')" :key="pIndex">
                                    {{ paragraph }}
                                </p>
                            </div>
                        </div>
                    </swiper-slide>
                </swiper>
                <div class="idea-list">
                    <div v-for="(item, index) in ideaList" :key="index" class="idea-item">
                        <div class="image-container">
                            <img :src="item.pcImgUrl" />
                        </div>
                        <div class="content">
                            <div class="title">{{ item.title }}</div>
                            <div class="description">
                                <p v-for="(paragraph, pIndex) in item.description.split('|')" :key="pIndex">
                                    {{ paragraph }}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="investment-tracks">
                <pane-title class="pane" title="重点赛道" subTitle="KEY TRACKS" />
                <div class="tracks-list">
                    <div v-for="(item, index) in tracksList" :key="index" class="tracks-item">
                        <div class="tracks-content">
                            <div class="tracks-title">{{$t('fields.key')}}-<span>{{ item.title }}</span></div>
                            <div class="tracks-description">
                                <p v-for="(paragraph, pIndex) in item.description.split('|')" :key="pIndex">{{
                                    paragraph }}</p>
                            </div>
                            <div class="arrow-icon">
                                <svg xmlns="http://www.w3.org/2000/svg" width="53" height="14" viewBox="0 0 53 14"
                                    fill="none">
                                    <path d="M0 13H51L38.8812 1" stroke="#333333" />
                                </svg>
                            </div>
                        </div>
                        <div class="tracks-image">
                            <img :src="item.pcImgUrl" />
                        </div>
                    </div>
                </div>
            </div>
            <div class="shareholder-strategy">
                <pane-title class="pane" title="投资策略" subTitle="INVESTMENT STRATEGY" />
                <div class="strategy-list">
                    <div v-for="(item, index) in strategyList" :key="index" class="strategy-item">
                        <div class="image-container">
                            <img :src="item.pcImgUrl" />
                        </div>
                        <div class="title">{{ item.title }}</div>
                        <div class="divider"></div>
                        <div class="description">
                            <p v-for="(paragraph, pIndex) in item.description.split('|')" :key="pIndex">
                                {{ paragraph }}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </el-page>
    </el-skeleton>
</template>

<script>
import PaneTitle from '../../components/PaneTitle/PaneTitle.vue';
export default {
    name: "invest",
    components: { PaneTitle },
    data() {
        return {
            loading: true,
            bannerImageUrl: null,
            swiperOption: {
                autoplay: {
                    delay: 5000,
                    disableOnInteraction: false
                },
                loop: true, // 循环滚动
                slidesPerView: 1,
                slidesPerView: 'auto',
                centeredSlides: true,
                spaceBetween: 8,
                observer: true,         // 监听自身变化
                observeParents: true,   // 监听父级变化
                watchOverflow: true, // 当滑块数量不足时自动隐藏分页器
                // pagination: {
                //     el: '.swiper-pagination',
                //     clickable: true
                // },
            },
            ideaList: [],
            tracksList: [],
            strategyList: []
        }
    },
    computed: {
        lang() {
            return this.$i18n.locale;
        },
        newsPageNo() {
            return Math.ceil(this.newsData.length / this.pageSize);
        },
        currentTrendsList() {
            const start = (this.currentPage - 1) * this.pageSize;
            const end = start + this.pageSize;
            return this.trendsList.slice(start, end)
        },
    },
    methods: {
        jumpDetail(item) {
            const link = item.jumpUrl;
            if (link === 'local') {
                window.open('/news-detail/' + item.id);
            } else if (link) {
                window.open(link)
            }
        },
        configData(record) {
            this.ideaList = (record['31'] && record['31'] || []).sort((a, b) => a.sort - b.sort)
            this.tracksList = (record['32'] && record['32'] || []).sort((a, b) => a.sort - b.sort)
            this.strategyList = (record['33'] && record['33'] || []).sort((a, b) => a.sort - b.sort)
        },
        getData(language) {
            this.$http.getOnlyContent({
                itemType: '3',
                platform: 'pc',
                language
            }).then(res => {
                this.loading = false;
                this.bannerImageUrl = res.imageMaps['30'] && res.imageMaps['30'][0] && res.imageMaps['30'][0].imgUrl
                this.configData(res.crmOweContentMaps)
            });
        },
        getDataByLang(lang) {
            if (lang === 'zh') {
                this.getData('china');
            } else {
                this.getData('english');
            }
        }
    },
    watch: {
        "$i18n.locale": {
            immediate: true,
            handler(v) {
                this.getDataByLang(v);
            }
        },
    }
}
</script>

<style scoped lang="less">
.invest-page {
    .pane {
        padding: 3rem 0;
    }

    .content-image {
        width: 100%;
        padding: 0 15rem;
        overflow: hidden;
        transition: transform 0.3s ease;

        &:hover {
            transform: scale(1.02);
        }

        img {
            width: 100%;
            height: auto;
            display: block;
        }
    }

}


.tracks-list {
    margin: 0 15rem;

    .tracks-item {
        display: flex;
        margin-bottom: 1.25rem;
        transition: transform 0.3s ease;
        background: linear-gradient(135deg, rgba(30, 90, 215, 0.06) 0.46%, rgba(11, 11, 128, 0.06) 99.53%);

        &:nth-child(even) {
            flex-direction: row-reverse;

            .tracks-content {
                .arrow-icon {
                    svg {
                        transform: scaleX(-1);
                    }
                }
            }
        }

        &:hover {
            transform: scale(1.02);
        }

        &:last-child {
            margin-bottom: 0;
        }
    }

    .tracks-content {
        flex: 3;
        padding: 2.5rem;
        display: flex;
        flex-direction: column;
        position: relative;
        background-image: url('../../assets/zdsd_icon.png');
        background-repeat: no-repeat;
        background-position: right bottom;
        background-size: 50% auto;

        .arrow-icon {
            width: 3.1875rem;
            height: 0.75rem;
            flex-shrink: 0;
            position: absolute;
            left: 2.5rem;
            bottom: 1.5rem;
        }
    }

    .tracks-title {
        color: #333;
        font-size: 1.5rem;
        font-style: normal;
        margin-bottom: 1.5rem;

        span {
            color: var(--primary-color);
            font-weight: 500;
        }
    }

    .tracks-description {
        color: #333;
        font-size: 1rem;
        font-style: normal;
        font-weight: 400;
        line-height: 2rem;

        p {
            margin: 0;
            margin-bottom: 0.75rem;

            &:last-child {
                margin-bottom: 0;
            }
        }
    }

    .tracks-image {
        flex: 7;
        aspect-ratio: 721/241;

        img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            display: block;
        }
    }
}

.invest-list {
    padding: 0 15rem;
    display: flex;
    flex-direction: column;
    gap: 1rem;

    .invest-item {}
}

.idea-list-mobile {
    display: none;
}

.idea-list {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 1rem;
    padding: 0 15rem;

    .idea-item {
        display: flex;
        flex-direction: column;
        height: 100%;

        .image-container {
            width: 100%;
            aspect-ratio: 469/267;
            overflow: hidden;
            flex-shrink: 0;

            img {
                width: 100%;
                height: 100%;
                object-fit: cover;
            }
        }

        transition: transform 0.3s ease;

        &:hover {
            transform: scale(1.02);
        }

        .content {
            padding: 1.5rem;
            background: linear-gradient(135deg, rgba(30, 90, 215, 0.50) 0.46%, rgba(11, 11, 128, 0.50) 99.53%), url('../../assets/tzln_txt_bg.png');
            background-size: cover;
            background-position: center;
            background-repeat: no-repeat;
            flex: 1;
            display: flex;
            flex-direction: column;

            .title {
                color: #FFF;
                font-family: "Source Han Sans CN";
                font-size: 1.5rem;
                font-style: normal;
                font-weight: 500;
                line-height: 2rem;
                margin-bottom: 1rem;
            }

            .description {
                color: #FFF;
                text-align: justify;
                font-family: "Source Han Sans CN";
                font-size: 1rem;
                font-style: normal;
                font-weight: 400;
                line-height: 2rem;
                flex: 1;

                p {
                    margin-bottom: 2rem;

                    &:last-child {
                        margin-bottom: 0;
                    }
                }
            }
        }
    }
}



.shareholder-strategy {
    background: url('../../assets/tzcl_bg.png');
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    margin-top: 4rem;
    padding-bottom: 4rem;
}

.strategy-list {
    padding: 0 15rem;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 1.25rem;

    .strategy-item {
        background: #FFF;
        box-shadow: 0px 4px 30px -2px rgba(13, 20, 138, 0.10);
        border-radius: 0.5rem;
        padding: 2rem;
        display: flex;
        flex-direction: column;
        transition: transform 0.3s ease;
        position: relative;
        overflow: hidden;

        &:hover {
            transform: scale(1.02);
        }

        .image-container {
            position: absolute;
            top: 0;
            right: 0;
            width: 12rem;
            height: auto;
            flex-shrink: 0;
            align-self: flex-end;
            margin-bottom: 2rem;

            img {
                width: 100%;
                height: 100%;
                object-fit: cover;
            }
        }

        .title {
            color: var(--333333, #333);
            font-family: "Source Han Sans CN";
            font-size: 1.5rem;
            font-style: normal;
            font-weight: 700;
            line-height: 2rem;
        }

        .divider {
            width: 3rem;
            height: 0.3125rem;
            flex-shrink: 0;
            background: linear-gradient(135deg, #1E5AD7 0.46%, #0B0B80 99.53%);
            margin: 1.5rem 0 3rem;
        }

        .description {
            color: var(--333333, #333);
            font-family: "Source Han Sans CN";
            font-size: 1rem;
            font-style: normal;
            font-weight: 400;
            line-height: 2rem;

            p {
                margin: 0;
                margin-bottom: 0.75rem;

                &:last-child {
                    margin-bottom: 0;
                }
            }
        }
    }
}

@media screen and (max-width: 767px) {


    .idea-list {
        display: none;
    }

    .idea-list-mobile {
        display: block;
        margin: 0 -1.333rem;

        .idea-item {
            width: 80%;
            aspect-ratio: 284/294;
            overflow: hidden;
            display: flex;
            align-items: center;

            &:after {
                content: "";
                position: absolute;
                background-color: fade(black, 50%);
                width: 100%;
                height: 100%;
            }

            .image-container {
                position: absolute;
                width: 100%;
                height: 100%;
                overflow: hidden;
                flex-shrink: 0;

                img {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                }
            }

            transition: none;


            .content {
                z-index: 1;
                position: relative;
                padding: 2rem;
                flex: 1;
                display: flex;
                flex-direction: column;
                align-items: center;

                .title {
                    color: #FFF;
                    font-family: "Source Han Sans CN";
                    font-size: 1.5rem;
                    font-style: normal;
                    font-weight: 500;
                    line-height: 2rem;
                    margin-bottom: 1rem;
                    text-align: center;
                }

                .description {
                    color: #FFF;
                    text-align: justify;
                    font-family: "Source Han Sans CN";
                    font-size: 1.16667rem;
                    font-style: normal;
                    font-weight: 400;
                    line-height: 2rem;
                    flex: 1;

                    p {
                        margin-bottom: 1rem;

                        &:last-child {
                            margin-bottom: 0;
                        }
                    }
                }
            }
        }
    }

    .tracks-list {
        margin: 0;

        .tracks-item {
            padding: 1rem;
            flex-direction: column;

            &:nth-child(even) {
                flex-direction: column;

            }

        }

        .tracks-content {
            background-image: none;
            padding: 1rem;

            .arrow-icon {
                display: none;
            }
        }

        .tracks-title {
            color: #333;
            font-size: 1.333rem;
            font-style: normal;
            margin-bottom: 0.75rem;
            font-weight: 500;

            span {
                color: var(--primary-color);
                font-weight: 500;
            }
        }

        .tracks-description {
            color: #333;
            font-size: 1.16667rem;
            font-style: normal;
            font-weight: 400;
            line-height: 2rem;

            p {
                margin: 0;
                margin-bottom: 0.75rem;

                &:last-child {
                    margin-bottom: 0;
                }
            }
        }

        .tracks-image {
            flex: 7;
            aspect-ratio: 721/241;

            img {
                width: 100%;
                height: 100%;
                object-fit: cover;
                display: block;
            }
        }
    }

    .shareholder-strategy {
        margin: 4rem -1.333rem 0;

        .strategy-list {
            grid-template-columns: 1fr;
            padding: 0 1rem;
            gap: 1.5rem;

            .strategy-item {
                box-shadow: 0px 4px 30px rgba(13, 20, 138, 0.10);
                border-top-left-radius: 1rem;
                border-bottom-right-radius: 1rem;
                border-top-right-radius: 0;
                border-bottom-left-radius: 0;

                .description {

                    font-size: 1.16667rem;
                    line-height: 2.25rem;
                }
            }
        }
    }

}
</style>